/*
https://okgithub.office.okcupid.com/OkCupid/okcupid/blob/master/cupid/docs/specs/billing-api/BillingWS.md#errors

# Errors

- Check parameters errors
	- Velocity checks on parameters
		- 122 => Unknown platform
		- 1502 => at least one or more fields are empty for CC params
		- 401 => at least one or more fields are empty for PPL params (paypal/init)
		- 403 => at least one or more fields are empty for PPL params (paypal/purchase)
	- Technical error while checking the parameters : 102, 119, 103
	- Technical error while checking fraud status (only for Credit card purchase) : 1503,
	1601, 1704, 1603, 1605

- Eligibility errors
	- Misc
		- 111 => Technical error while trying to get uber
	- Fraud status
		- 1607 => User has limited profile
		- 1606 => IP for user is restricted
		- 120 => Technical error while checking fraud status
	- Catalog velocity check => all those errors occur when we cannot get the product from
	the catalog : 117, 113, 704, 705, 708, 707, 1002, 180
	- Check on subscription => all those errors occur when we try to get the existing
	subscriptions for the user : 114, 501, 502, 1106
	- If subscription exists, the following error will appear if the user has a product
	that is incompatible with the current purchase (Ex. : the user already has A-List and
	tries to purchase A-List) : 117
	- When trying to purchase using payment informations, those errors will occur when
	the we cannot get the payment informations : 116, 601, 604, 1204

- Purchase
	- PPL Purchase => all those errors shows that the purchase with PPL failed : 104, 407,
	408, 409, 410, 411, 412, 413, 414, 415
	- PPL Init => all those errors shows that the init transaction with PPL failed : 101,
	405, 406
	- CC Purchase => all those errors shows that the purchase with CC failed : 1507, 1506,
	1505, 1512, 1513, 121, 1521, 1522, 1523, 1532, 1514, 1515, 1516, 1531, 1520, 1518, 1517,
	1527, 1608, 1702, 1703

- This part is what happened when the purchase is complete (create a transaction, a payment,
a subscription,...), those errors should not happen but here they are just in case :
	- Errors when creating payment informations fails : 105, 602, 604, 603, 1202, 1203
	- Errors when creating subscription fails : 106, 124, 505, 503, 1102, 512, 514, 1110, 1112
	- Errors when creating transaction fails : 107, 305, 303, 902
	- Errors when creating features fails :
		- Generic errors : 135, 2001
		- Specific errors for subscriptions : 2002, 2003, 2004, 2021, 2017, 2007, 2029, 2018
		- Specific errors for boost tokens : 2010
	- Errors when sending the purchase email fails : 182, 2101, 2102

*/

import _str from "shared/util/_str";

export default function getApiError(code) {
	switch (Math.abs(code)) {
		case 122: // unknown platform
		case 401: // missing field for paypal from paypal/init
		case 403: // missing field for paypal from paypal/init
		case 102: // technical error checking param
		case 119: // technical error checking param
		case 103: // technical error checking param
		case 1503: // technical error checking fraud status
		case 1601: // technical error checking fraud status
		case 1704: // technical error checking fraud status
		case 1603: // technical error checking fraud status
		case 1605: // technical error checking fraud status
		case 111: // Technical error while trying to get uber
		case 1687: // provisional profile
		case 1606: // ip restricted
		case 120: // technical error checking fraud
		case 114: // error checking subscription
		case 501: // error checking subscription
		case 502: // error checking subscription
		case 1106: // error checking subscription
		case 105: // error creating payment info
		case 602: // error creating payment info
		case 603: // error creating payment info
		case 1202: // error creating payment info
		case 1203: // error creating payment info
		case 107: // couldn't create transaction
		case 305: // couldn't create transaction
		case 303: // couldn't create transaction
		case 902: // couldn't create transaction
		case 135: // generic feature (?) creation error
		case 2001: // generic feature (?) creation error
		case 2002: // specific error for subscriptions? wtf does that mean?
		case 2003: // specific error for subscriptions? wtf does that mean?
		case 2004: // specific error for subscriptions? wtf does that mean?
		case 2021: // specific error for subscriptions? wtf does that mean?
		case 2017: // specific error for subscriptions? wtf does that mean?
		case 2007: // specific error for subscriptions? wtf does that mean?
		case 2029: // specific error for subscriptions? wtf does that mean?
		case 2018: // specific error for subscriptions? wtf does that mean?
		case 2010: // specific error for subscriptions? wtf does that mean?
		case 182: // email failed to send, bfd
		case 2101: // email failed to send, bfd
		case 2102: // email failed to send, bfd
			return {
				text: _str("Oops, we couldn’t process your transaction, please try again later!"),
				escalate: false,
			};

		// couldn't get product
		case 113:
		case 704:
		case 705:
		case 708:
		case 707:
		case 1002:
		case 180:
			return {
				text: _str("We couldn’t find that product, sorry!"),
				escalate: false,
			};

		// - If subscription exists, the following error will appear if the user has a product
		// that is incompatible with the current purchase (Ex. : the user already has A-List and
		// tries to purchase A-List)
		case 117:
			return {
				text: _str("You already have that product!"),
				escalate: false,
			};

		// couldn't get existing payment info
		case 116:
		case 601:
		case 604:
		case 1204:
			return {
				text: _str("We couldn’t use your stored information!"),
				escalate: false,
			};

		// paypal init failed
		case 101:
		case 405:
		case 406:
			return {
				text: _str("Your PayPal transaction failed!"),
				escalate: false,
			};

		// paypal purchase failed
		case 104:
		case 407:
		case 408:
		case 409:
		case 410:
		case 411:
		case 412:
		case 413:
		case 414:
		case 415:
			return {
				text: _str("Your PayPal transaction failed!"),
				escalate: true,
			};

		// cc purch failed
		case 1507:
		case 1506:
		case 1505:
		case 1512:
		case 1513:
		case 121:
		case 1521:
		case 1522:
		case 1523:
		case 1532:
		case 1514:
		case 1515:
		case 1516:
		case 1531:
		case 1520:
		case 1518:
		case 1517:
		case 1527:
		case 1608:
		case 1702:
		case 1703:
			return {
				text: _str("Your credit card transaction failed!"),
				escalate: false,
			};

		case 1502:
			return {
				text: _str("That postal code didn’t work!"),
				escalate: false,
			};

		// creating sub fails
		case 106:
		case 124:
		case 505:
		case 503:
		case 1102:
		case 512:
		case 514:
		case 1110:
		case 1112:
			return {
				text: _str("We couldn’t add that product, please contact customer support!"),
				escalate: true,
			};


		default:
			return {
				text: _str("Oops, we couldn’t process your transaction!"),
				escalate: false,
			};
	}
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getApiError.js